import type { User } from '@supabase/supabase-js';
import type { AppUser } from '../types/api';

/**
 * The name a user is shown under to other users in live collaboration: the edit-lock
 * highlight ("currently being edited by …") and the connected-users presence channel.
 *
 * Both derive it the same way so one person isn't two different names on screen.
 *
 * Everything comes from the decoded JWT — no request to the auth server, which is what
 * auth.getUser() does and why editors used to show up as "Unknown".
 */
export const getDisplayUserName = (
  appUser: AppUser | null | undefined,
  user: User | null | undefined
): string =>
  appUser?.name
  || appUser?.email
  || (user?.user_metadata?.name as string | undefined)
  || user?.email
  || 'Unknown';
